import { ThemeProvider } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { nb } from 'date-fns/locale';

import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import { useEffect } from 'react';
import './App.css';
import type { IAuthResponse } from './auth/models/auth.response';
import { setCredentials } from './auth/store/reducers/auth.slice';
import Router from './Router';
import { getCredentialsFromLS } from './shared/services/localstorage';
import { useAppDispatch } from './store/hooks/redux';
import ErrorBoundary from './shared/components/ErrorBoundary';

// Translations
import './i18n';
import { useTranslation } from 'react-i18next';
import useAppInitLanguage from './shared/hooks/app-init-hook';
import { ColorModeContext, useMode } from '@/theme';
import { GoogleMapsGlobalStyles } from '@/shared/components/GoogleMapsGlobalStyles';
import { AppToaster } from '@/shared/components/CustomToaster';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function App() {
  const dispatch = useAppDispatch();
  const [theme, colorMode] = useMode();
  const credentials: IAuthResponse | null = getCredentialsFromLS();

  const { i18n } = useTranslation();

  useAppInitLanguage(true);

  useEffect(() => {
    if (credentials) {
      dispatch(setCredentials(credentials));
    }
  }, []);

  return (
    <div>
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <ErrorBoundary>
            <CssBaseline />
            <GoogleMapsGlobalStyles />
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={nb}>
              <AppToaster />
              <Router></Router>
            </LocalizationProvider>
          </ErrorBoundary>
        </ThemeProvider>
      </ColorModeContext.Provider>
    </div>
  );
}

export default App;
